/**
 * Front-desk Guest Requests queue API.
 *
 * One feed for everything a guest asks for from the guest app:
 * service requests (housekeeping / maintenance / concierge) and
 * room-service food orders, normalized by the backend into a single
 * card shape with buckets new / in_progress / done.
 */
import apiClient from './ApiClient';

// Card kind → URL segment for the action endpoints
const KIND_SEGMENT = {
  service_request: 'service',
  room_service_order: 'order',
};

// ApiClient's response interceptor already returns response.data, so these
// return the payload directly — reading .data again yields undefined.
class GuestRequestsService {
  async getRequests() {
    return apiClient.get('/v1/guest-requests');
  }

  async acknowledge(item) {
    return apiClient.post(
      `/v1/guest-requests/${KIND_SEGMENT[item.kind]}/${item.id}/acknowledge`
    );
  }

  async complete(item) {
    return apiClient.post(
      `/v1/guest-requests/${KIND_SEGMENT[item.kind]}/${item.id}/complete`
    );
  }
}

const guestRequestsService = new GuestRequestsService();
export default guestRequestsService;
